import React from 'react';
import BsTooltip from 'bootstrap/js/src/tooltip';

class Tooltip extends React.Component {
  constructor(props) {
    super(props);
    this.ref = React.createRef();
  }

  componentDidMount() {
    this.tooltip = new BsTooltip(this.ref.current, {
      trigger: 'manual',
    });
  }

  componentDidUpdate() {
    this.tooltip.hide();
    this.tooltip.show();
  }

  render() {
    return (
      <div
        data-bs-toggle="tooltip"
        data-bs-placement="right"
        data-original-title={this.props.text}
        ref={this.ref}
        className="d-block"
        onMouseOut={() => this.tooltip.hide()}
        onClick={() => this.tooltip.show()}
      >
        {this.props.children}
      </div>
    );
  }
}

export default Tooltip;
